module.exports = __webpack_public_path__ + "static/media/dennisnieuwenhuys.142f1bfa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/dennisnieuwenhuys.webp
// module id = 219
// module chunks = 0